const prepareFeaturesData = (features: any, inputs: any, weights: any) => {
  const data: any = {};

  for (const [key, value] of Object.entries(features)) {
    data[value as any] = {
      weight: weights[key] || 0,
      input: inputs[key] || 0,
    };
  }

  return data;
};

export default prepareFeaturesData;
